import React from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import loadClasses from "./load.module.css";

function Load() {
    return (
        <SkeletonTheme>
            <div className={loadClasses["Table"]}>
                <table>
                    <thead>
                        <tr>
                            <th>Class</th>

                            <th>Start Date Time</th>

                            <th>End Time</th>
                            <th>Course Name</th>
                            <th>Batch Size</th>
                            <th>Lesson Plan</th>
                            <th>Created </th>
                            <th>Cancel Reason</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {Array(3)
                            .fill()
                            .map(() => (
                                <tr>
                                    <td>
                                        <Skeleton height={"1rem"} />
                                    </td>
                                    <td>
                                        <Skeleton />
                                    </td>
                                    <td>
                                        <Skeleton />
                                    </td>

                                    <td>
                                        <Skeleton />
                                    </td>
                                    <td>
                                        <Skeleton />
                                    </td>
                                    <td>
                                        <Skeleton />
                                    </td>
                                    <td>
                                        <Skeleton />
                                    </td>
                                    <td>
                                        <Skeleton />
                                    </td>
                                    <td>
                                        <Skeleton />
                                    </td>
                                </tr>
                            ))}
                    </tbody>
                </table>
            </div>
        </SkeletonTheme>
    );
}

export default Load;
